"use client";
import { motion, useAnimation } from "framer-motion";
import { useEffect } from "react";

import one from "../../../src/assets/photos/gallery/1.webp";
import two from "../../../src/assets/photos/gallery/2.webp";
import three from "../../../src/assets/photos/gallery/3.webp";
import four from "../../../src/assets/photos/gallery/4.webp";
import five from "../../../src/assets/photos/gallery/5.webp";
import six from "../../../src/assets/photos/gallery/6.webp";
import seven from "../../../src/assets/photos/gallery/7.webp";
import eight from "../../../src/assets/photos/gallery/8.webp";
import nine from "../../../src/assets/photos/gallery/9.webp";
import ten from "../../../src/assets/photos/gallery/10.webp";
import eleven from "../../../src/assets/photos/gallery/11.webp";
import twelve from "../../../src/assets/photos/gallery/12.webp";
import thirteen from "../../../src/assets/photos/gallery/13.webp";
import fourteen from "../../../src/assets/photos/gallery/14.webp";
import fifteen from "../../../src/assets/photos/gallery/15.webp";
import sixteen from "../../../src/assets/photos/gallery/16.webp";
import seventeen from "../../../src/assets/photos/gallery/17.webp";
import eighteen from "../../../src/assets/photos/gallery/18.webp";
import nineteen from "../../../src/assets/photos/gallery/19.webp";
import twenty from "../../../src/assets/photos/gallery/20.webp";
import twentyone from "../../../src/assets/photos/gallery/21.webp";
import twentytwo from "../../../src/assets/photos/gallery/22.webp";
import twentythree from "../../../src/assets/photos/gallery/23.webp";


export default function InfinitePhotoScroll({ duration = 45 }) {
  const controls = useAnimation();

  const photos = [
    one, two, three, four, five, six, seven, eight, nine, ten,
    eleven, twelve, thirteen, fourteen, fifteen, sixteen, seventeen,
    eighteen, nineteen, twenty, twentyone, twentytwo, twentythree
  ];

  useEffect(() => {
    controls.start({
      x: ["0%", "-100%"],
      transition: {
        repeat: Infinity,
        duration,
        ease: "linear",
      },
    });
  }, [controls, duration]);

  return (
    <div className="overflow-hidden w-full">
      <motion.div className="flex gap-5" animate={controls}>
        {photos.concat(photos).map((photo, index) => (
          <motion.div
            key={index}
            className="flex-shrink-0 rounded-xl overflow-hidden transition-all duration-300"
            whileHover={{ scale: 1.05, y: -5 }}
            onHoverStart={() => controls.stop()}
            onHoverEnd={() =>
              controls.start({
                x: ["0%", "-100%"],
                transition: {
                  repeat: Infinity,
                  duration,
                  ease: "linear",
                },
              })
            }
          >
            <img
              src={photo}
              alt={`gallery-photo-${index + 1}`}
              className="object-cover w-[238px] h-[238px]"
            />
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
}
